<div class="page">
  <section class="page__header">
    <custom-app-bar
      [title]="'cart_detail.title' | translate"
      [hasCloseButton]="!(isMobile$ | async)"
    >
        @if (canShareProducts$ | async) {
            <button rightContent customButton appearance="text">
                <svg-icon
                        class="ep-icon"
                        src="./assets/icons/vector.svg"
                        (click)="onClickShareAllProducts()"
                ></svg-icon>
            </button>
        }
    </custom-app-bar>
  </section>
  <section class="page__content" *ngIf="isCartEmpty$ | async">
    <app-empty-cart [isLoggedIn]="isLoggedIn$ | async"></app-empty-cart>
  </section>
  <section class="page__content" *ngIf="!(isCartEmpty$ | async)">
    <app-cart-summary
      class="cart-detail without-side-margin"
      [cartDetail]="cartDetail$ | async"
    ></app-cart-summary>
    <div class="cart-content without-side-margin">
      <div *ngIf="cartLines$ | async as cartLines">
        <p class="n-products-in-cart">
          {{
            "cart_detail.n_products_in_cart"
              | translate: { quantity: (cartQuantity$ | async) ?? 0 }
          }}
        </p>
        <ep-item-tile
          *ngFor="let cartLine of cartLines; trackBy:cartLineTrackBy"
          [item]="cartLine"
          [promotionCode]="cartLine.promotionCode"
        ></ep-item-tile>
      </div>
    </div>

    <ng-container
            *ngIf="promotions$ | async as promotions"
    >
      <ng-container *ngIf="promotions.length > 0">
        <h2 class="similar-products__title">
          {{'cart_detail.promotions' | translate}}
        </h2>
        <div class="cart-content">
          <app-promotion-list
                  [promotions]="promotions"
          ></app-promotion-list>
        </div>
      </ng-container>
    </ng-container>

    <ng-container
            *ngIf="similarProducts$ | async as similarProducts"
    >
      <ng-container *ngIf="similarProducts.length > 0">
        <h2 class="similar-products__title">
          {{'cart_detail.are_you_sure_you_have_everything' | translate}}
        </h2>
        <div class="similar-products without-side-margin">
          <ep-item-tile
                  *ngFor="let product of similarProducts"
                  [item]="product"
          ></ep-item-tile>
        </div>
      </ng-container>
    </ng-container>


    <app-cart-summary
      class="cart-detail without-side-margin"
      *ngIf="isMobile$ | async"
      [cartDetail]="cartDetail$ | async"
    ></app-cart-summary>
  </section>
</div>
